<template>
  <roe-chart-table-switch name="Marginal Cost for Plan Sponsor">
    <template #chartView>
      <div class="table">
        <div class="table-row" v-for="year in lagIndicatorYears">
          <div class="table-unit table-desc-unit">
            {{ year }}
          </div>
          <div
            class="table-unit table-graph-unit"
            v-for="(design, index) in designs"
          >
            <roe-horizontal-bar
              :value="marginalCostPercent(design.marginal_cost[year])"
              :price="design.marginal_cost[year]"
              :color="designColorClasses[index]"
            ></roe-horizontal-bar>
          </div>
        </div>
      </div>
    </template>

    <template #tableView>
      <div class="table">
        <div class="table-row" v-for="year in lagIndicatorYears">
          <div class="table-unit table-desc-unit">
            {{ year }}
          </div>
          <div class="table-unit" v-for="(design, index) in designs">
            {{ design.marginal_cost[year] | currency({ fractionCount: 0 }) }}
            <div
              v-if="index !== 0"
              class="table-unit-statistics"
              :class="differenceClass(design, year)"
            >
              <div class="table-unit-statistics-label">
                {{
                  difference(design, year)
                    | currency({ fractionCount: 0 })
                    | plus
                }}
              </div>
              <div class="table-unit-statistics-label">
                {{ differenceInPercent(design, year) | percentage | plus }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </roe-chart-table-switch>
</template>

<script>
import RoeHorizontalBar from "@/components/charts/HorizontalBar";
import RoeChartTableSwitch from "@/components/alternative-designs/_shared/ChartTableSwitch";
import { mapGetters } from "vuex";

export default {
  name: "RoeMarginalCost",
  computed: {
    ...mapGetters([
      "originalDesign",
      "designs",
      "designColorClasses",
      "lagIndicatorYears"
    ]),
    maxMarginalCost() {
      return Math.max(
        ...this.designs.map(d => Object.values(d.marginal_cost)).flat()
      );
    }
  },
  components: {
    RoeHorizontalBar,
    RoeChartTableSwitch
  },
  methods: {
    difference(plan, year) {
      return plan.marginal_cost[year] - this.originalDesign.marginal_cost[year];
    },
    differenceInPercent(plan, year) {
      if (this.originalDesign.marginal_cost[year] === 0) return 0;
      return (
        this.difference(plan, year) / this.originalDesign.marginal_cost[year]
      );
    },
    differenceClass(plan, year) {
      return this.difference(plan, year) > 0
        ? "table-unit-statistics-up"
        : "table-unit-statistics-down";
    },
    marginalCostPercent(value) {
      let percent = value / this.maxMarginalCost;
      return percent < 0.01 ? 0.01 : percent;
    }
  }
};
</script>
